import React from 'react';

const SvgChevronRight: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.383 29.768"
      {...props}
    >
      <path
        d="M2.121 2.122l12.762 12.762L2.121 27.647"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgChevronRight;
